// extracted by mini-css-extract-plugin
export default {"button":"FB672JKqbj55GoiD8ASp"};